import qs from "qs";
import * as R from "ramda";

import { sortObjectKeys } from "./objects";

export const parseQueryStringAsNumber = R.when(
  R.compose(
    R.not,
    R.anyPass([
      R.isNil,
      R.compose(
        Number.isNaN,
        Number
      )
    ])
  ),
  Number
);

export const parseQueryStringArray = R.compose(
  R.defaultTo([]),
  R.when(
    R.compose(
      R.not,
      Array.isArray
    ),
    R.when(Boolean, R.split(","))
  )
);

export const parseQueryArrayWith = (pred = R.always) =>
  R.compose(
    R.map(pred),
    parseQueryStringArray
  );

export const createQueryString = (params = {}, encode = true) =>
  qs.stringify(sortObjectKeys(params), {
    arrayFormat: "repeat",
    encode
  });

export const defaultQueryStringDecoderKeywords = {
  true: true,
  false: false,
  null: null,
  undefined: undefined
};

export const decodeQueryString = (
  query = "",
  transformer = {},
  keywords = defaultQueryStringDecoderKeywords
) =>
  R.evolve(
    transformer,
    qs.parse(query, {
      ignoreQueryPrefix: true,
      comma: true,
      // Parse "true" string to boolean
      decoder: (value, defaultDecoder) => {
        if (value in keywords) {
          return keywords[value];
        }
        return defaultDecoder(value);
      }
    })
  );
